let local = false;

export const setLocal = (newLocal: boolean) => {
  local = newLocal;
};

export const isLocal = () => {
  return local;
};
